import { forwardRef, createElement } from 'react';

function IconLogOut(props, svgRef) {
  return createElement("svg", Object.assign({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.25 4.5H6.5v15h6.75a1.25 1.25 0 110 2.5h-7A2.25 2.25 0 014 19.75V4.25A2.25 2.25 0 016.25 2h7a1.25 1.25 0 110 2.5zm6.384 2.616l-.102-.091a1.25 1.25 0 00-1.666 1.859l1.867 1.866H11.75l-.128.007a1.25 1.25 0 00.128 2.493h7.982l-1.866 1.866-.091.102a1.25 1.25 0 001.859 1.666l4-4 .08-.089.05-.063.068-.106.058-.112.049-.127.03-.108.016-.088.012-.112L24 12l-.004-.096-.016-.13-.03-.127-.03-.087-.046-.107-.046-.086-.065-.1a1.267 1.267 0 00-.13-.15l-4-4zm4.084 4.094l-.084-.094c.03.03.058.061.084.094z",
    fill: "currentColor"
  }));
}

var LogOut = /*#__PURE__*/forwardRef(IconLogOut);

export default LogOut;
//# sourceMappingURL=LogOut.js.map
